import { loadUsers, getTotalUsers } from '../api/users';
import { Dispatch } from 'redux';
import { getCurrentToken } from './store';
import { filtros } from '../types/general-types';
const initialState = {
  users: null,
  filtros:null,
  totalusuariosActivos:null
};

const USERS = 'USERS';
const CLEARUSERS = 'CLEARUSERS';
const FILTROS = 'FILTROS';
const TOTALUSUARIOS = 'TOTALUSUARIOS';

const setUsers = (users: any) => ({ type: USERS, payload: users });
const clearUsers = () => ({ type: CLEARUSERS, payload: null });
const setFiltros = (filtros: filtros | null) => ({type: FILTROS, payload: filtros});
const setTotalUsuariosActivos = (total:number) => ({type: TOTALUSUARIOS, payload: total})

export const fetchUsers = (offset: number, apellido?: string, nombre?: string, idNumero?: string, email?: string) => {
  return async (dispatch: Dispatch) => {
    const currentToken = getCurrentToken();
    const res = await loadUsers(currentToken, offset, apellido, nombre, idNumero, email);

    dispatch(setUsers(res));
  };
};

export const limpiarUsers = () => {
  return (dispatch: Dispatch) => {
    return dispatch(clearUsers())
  }
}

export const setearFiltros = (filtros:filtros | null) => {
  return (dispatch: Dispatch) => {
    return dispatch(setFiltros(filtros))
  }
}

export const setearTotalUsuariosActivos = () => {
  return async (dispatch: Dispatch) => {
    const currentToken = getCurrentToken();
    const total = await getTotalUsers(currentToken);
    return dispatch(setTotalUsuariosActivos(total.cantidad))
  }
}



const usersReducer = (state = initialState, action: any) => {
  switch (action.type) {
    case USERS:
      const newUsers = action.payload;
      const updatedUsers = state.users === null ? [...newUsers] : [...state.users, ...newUsers];
      return { ...state, users: updatedUsers };
    case CLEARUSERS:
      return { ...state, users: null };
      case FILTROS:
        return {...state, filtros:action.payload};
      case TOTALUSUARIOS:
        return { ...state, totalusuariosActivos: action.payload };
    default:
      return { ...state };
  }
};

export default usersReducer;
